<template>
  <!-- <div> -->
    <my-popup
    title="选择链接"
    width="800"
    :flag="selectDialogVisible"
    @close="handleClose"
    zIndex="100000"
  >
    <div class="new-table-box" style="margin-top: 20px" >
      <el-table ref="goodsAnalysisTable" :data="tableData"
        :header-cell-style="{ background: '#fafafa' }" max-height="700px" v-loading="tableLoading"
       >
        <!-- 暂无数据修改 -->
        <template slot="empty">
          <div>
            <img src="@/assets/images/default/暂无任何数据.png" />
            <span style="margin-left: -140px">暂无任何数据</span>
          </div>
        </template>
        <!-- 表头 -->
        <el-table-column label="链接名称" prop="name" width="200px">
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              :content="scope.row.name"
              placement="top-start"
            >
                <div class="linkName">
                    {{ scope.row.name }}
                </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="链接" prop="link" width="400px">
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              :content="scope.row.link"
              placement="top-start"
            >
                <div class="linkName">
                    {{ scope.row.link }}
                </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
           <div style="display: flex;">
            <el-button type="text" class="edit_btn" @click="selectLink(scope.row)">选择</el-button>
            <el-button type="text" class="edit_btn" style="margin-left: 12px"  @click="handleDeleteLink(scope.row)">删除</el-button>
           </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="new-pagination-page" style="margin-top: 20px;text-align: right;">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 50, 100, 500, 1000]" :total="total" :page-size="pageInfo.size"
        :current-page="pageInfo.current" :disabled="tableLoading" @size-change="handleSizeChange"
        @current-change="handleCurrentChange"></el-pagination>
    </div>
    </my-popup>
</template>
<script>
import {getSellerLinkConfig,deleteLink} from "@/api/marketing/shortLink"
import myPopup from "@/components/myPopup";
export default {
  components: {
    myPopup
  },
  props: {
    selectDialogVisible: {
      type: Boolean,
      defalut: false,
    },
  },
  data() {
    return {
      tableLoading: false,
      pageInfo: {
        current: 1,
        size: 10,
      },
      tableData: [],
      total: 0
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getSellerLinkConfigList()
  },
  mounted() {
  
  },
  methods: {
    async getSellerLinkConfigList() {
      this.tableLoading = true
      try {
        const res = await getSellerLinkConfig(this.pageInfo)
        if(res.code==1) {
          this.tableData = res.data.records || []
          this.total = res.data.total
          this.tableLoading = false
        }else {
          this.tableLoading = false
        }
      } catch (error) {
        this.tableLoading = false
      }
    },
    selectLink(row) {
      this.$emit("selectLink", row);
      this.handleClose();
    },
    handleDeleteLink(row) {
      this.$confirm("此操作将永久删除该链接, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async() => {
          const res = await deleteLink(row.id)
          if(res.code==1) {
            this.$message.success("删除成功!");
            this.pageInfo.current = this.tableData.length > 1 ? this.pageInfo.current : this.pageInfo.current > 1 ?  - 1 : 1;
            this.getSellerLinkConfigList()
          }
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    handleClose() {
      this.$emit("close");
    },
    // 处理分页逻辑
    handleSizeChange(size) {
      this.pageInfo.current = 1;
      this.pageInfo.size = size;
      this.getSellerLinkConfigList()
    },
    handleCurrentChange(current) {
      this.pageInfo.current = current;
      this.getSellerLinkConfigList()
    },
  },
};
</script>
<style lang="scss" scoped>
.linkName {
  display: inline-block;
  vertical-align: middle;
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.edit_btn {
  color: #7f85e9;
  width: auto;

  &:hover {
    color: #fe4d45;
  }
}
/deep/ .el-dialog__wrapper {
  z-index: 999999 !important;
  }
</style>
